const ITEMS = [
  "Nationwide coverage — all 50 states",
  "Puerto Rico",
  "Guam",
  "DWG / PDF deliverables",
  "Matterport 3D scans",
  "Field measured in person",
  "Existing conditions drawings",
  "Files in 7–10 days",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item, i) => (
      <span key={i} className="flex items-center">
        <span className="whitespace-nowrap font-mono text-xs uppercase tracking-[0.3em] text-slate-400">
          {item}
        </span>
        <span className="mx-8 font-mono text-xs text-laser">+</span>
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-cad/15 bg-surface/60 py-4"
      aria-hidden="true"
    >
      <div className="flex w-max animate-marquee">
        <Row />
        <Row />
      </div>
    </div>
  );
}
